import {SecureService} from "@/services/superclasses/secure-service";
import {PersonNotification} from "@/interfaces/person-notification";

const api = window.contextPath + '/rest/notifications';

export class NotificationSecureService extends SecureService {
    public loadByPerson = async (args: {
        getAll?: boolean,
        first?: number,
        max?: number
    }): Promise<PersonNotification> => {
        return this.data(await this.get<PersonNotification>(`${api}/by-person`,
            {
                params: args,
            }));
    };

    public loadUnreadCount = async (): Promise<number> => {
        return this.data(await this.get<number>(`${api}/unread-count`))
    };

    public loadCount = async (args: {
        getAll?: boolean
    }): Promise<number> => {
        return this.data(await this.get<number>(`${api}/count`,
            {
                params: args,
            }))
    };

    public clicked = async (personNotificationId: number): Promise<void> => {
        return this.data(await this.post<void>(`${api}/clicked/` + personNotificationId))
    };

    public clickedAll = async (): Promise<void> => {
        return this.data(await this.post<void>(`${api}/clicked`))
    };

    public seen = async (personNotificationIds: string): Promise<void> => {
        return this.data(await this.post<any>(`${api}/seen/` + personNotificationIds))
    };

    public seenAll = async (): Promise<void> => {
        return this.data(await this.post<any>(`${api}/seen`))
    };

    public loadSettings = async (): Promise<any> => {
        return this.data(await this.get<any>(`${api}/settings`));
    };

    public saveSettings = async (notificationSettings: any): Promise<any> => {
        return this.data(await this.post<any>(`${api}/settings`, notificationSettings));
    };
}

export const notificationSecureService = new NotificationSecureService()